"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { switchAnatomy } from "@chakra-ui/react/anatomy"

const switchRecipe = defineSlotRecipe({
  className: "hydrologiq-switch",
  slots: switchAnatomy.keys(),
  variants: {
    variant: {
      hydrologiq: {
        control: {
          borderRadius: "full",
          transition: "background-color 0.2s ease",
          bg: "#444444", // Brand grey for off state
          border: "none",
          position: "relative",
          width: "2.7rem",
          height: "1.25rem",
          _checked: {
            bg: "#a170d9", // Brand purple for on state
          },
        },
        thumb: {
          bg: "white !important",
          borderRadius: "full",
          transition: "transform 0.2s ease",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
          width: "1.1rem",
          height: "1rem",
          top: "0.125rem",
          left: "0.125rem",
          transform: "translateX(0.175rem) translateY(0.125rem)",
          // The track is fixed at 2.7rem, so the travel is too (2.7 - 1.1 thumb - 2 × 0.175
          // gap). Chakra's default comes from the size prop and stops short at size="sm".
          _checked: {
            translate: "1.25rem 0",
          },
        },
      },
      small: {
        control: {
          borderRadius: "full",
          transition: "background-color 0.2s ease",
          bg: "#444444", // Brand grey for off state
          border: "none",
          position: "relative",
          height: "0.8rem",
          width: "1.6rem",
          _checked: {
            bg: "#a170d9", // Brand purple for on state
          },
        },
        thumb: {
          bg: "white !important",
          borderRadius: "full",
          transition: "transform 0.2s ease",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
          height: "0.6rem",
          width: "0.6rem",
          top: "0.125rem",
          left: "0.125rem",
          transform: "translateX(0.15rem) translateY(0.1rem)",
          _checked: {
            transform: "translateX(-0.365rem) translateY(0.1rem)",
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: "hydrologiq",
  },
})

export default switchRecipe
